import * as React from 'react';
import {useRoute} from 'react-router5';
import LessonBuilder from 'components/LessonBuilder';
import {Helmet} from 'react-helmet';

/**
 * The create lesson page
 * @constructor
 */
export default function CreateLesson(): React.ReactElement {
  const {router} = useRoute();
  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Создать урок</title>
      </Helmet>
      <LessonBuilder
        onCreated={() => (
          router.navigate('lessons')
        )}
      />
    </React.Fragment>
  );
}
